<ion-content>
  <div class="constrained-content">
    <ion-grid class="constrained-content">
      <ion-row>
        <ion-col size-md="4" size="12" class="settings-title-section">
          <h1><ion-icon name="folder-open-outline"></ion-icon>Projects</h1>
          <p class="subtitle">
            Projects should be used by different teams to group conversations
            and channels together. You can also set different permissions,
            ticket types, and other configurations for each project.
          </p>
          <p class="subtitle" style="opacity: 1; margin-bottom: 15px">
            <a
              href="https://docs.unthread.io/account-setup/projects-permissions"
              target="_blank"
            >
              Learn more about projects
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </a>
          </p>
        </ion-col>
        <ion-col size-md="8" size="12">
          <div class="flex-space-between" style="padding: 15px 5px 0 3px">
            <div class="button-container flexed-align-center">
              <ion-searchbar
                mode="ios"
                placeholder="Search..."
                showCancelButton="never"
                [(ngModel)]="searchText"
                (ionChange)="handleFilters()"
                class="rounded-search-bar"
              >
              </ion-searchbar>
            </div>

            <div class="button-container flexed-align-center">
              <ion-button
                (click)="createProject()"
                *ngIf="authService.isTenantAdmin"
              >
                <ion-icon name="add-outline"></ion-icon>
                <span class="text-with-left-icon hidden-sm">
                  Create project
                </span>
              </ion-button>
            </div>
          </div>
          <div class="projects-cards-container">
            <ion-card
              *ngFor="let project of filteredProjects"
              class="project-card outline-card"
            >
              <ion-card-content>
                <div class="project-card-content">
                  <!-- Project Image/Icon -->
                  <div class="project-image-container">
                    <img
                      *ngIf="project.supportLogo"
                      [src]="project.supportLogo"
                      [alt]="project.name + ' logo'"
                      class="project-logo"
                    />
                    <ion-icon
                      *ngIf="!project.supportLogo"
                      name="folder-outline"
                      class="project-icon"
                    ></ion-icon>
                  </div>

                  <!-- Project Details -->
                  <div class="project-details">
                    <h2
                      class="row-title row-link project-name"
                      (click)="editProject(project.id)"
                    >
                      {{ project.name }}
                    </h2>

                    <p class="project-description" *ngIf="project.description">
                      {{ project.description }}
                    </p>

                    <div class="project-meta">
                      <div class="meta-item">
                        <ion-icon
                          [name]="
                            project.visibility === 'public'
                              ? 'lock-open-outline'
                              : 'lock-closed-outline'
                          "
                        ></ion-icon>
                        <span>{{ project.visibility | titlecase }}</span>
                      </div>
                      <div class="meta-item">
                        <ion-icon
                          [name]="
                            project.isExternal
                              ? 'earth-outline'
                              : 'business-outline'
                          "
                        ></ion-icon>
                        <span>{{
                          project.isExternal
                            ? "External Support"
                            : "Internal Support"
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Action Buttons -->
                  <div class="project-actions">
                    <ion-button
                      fill="clear"
                      size="small"
                      (click)="viewProject(project); $event.stopPropagation()"
                      class="button-clear-hover-primary"
                    >
                      <ion-icon name="eye-outline"></ion-icon>
                      <span class="hidden-sm text-with-left-icon">View</span>
                    </ion-button>
                    <ion-button
                      fill="clear"
                      size="small"
                      (click)="
                        editProject(project.id); $event.stopPropagation()
                      "
                      class="button-clear-hover-primary"
                    >
                      <ion-icon name="create-outline"></ion-icon>
                      <span class="hidden-sm text-with-left-icon">Edit</span>
                    </ion-button>
                  </div>
                </div>
              </ion-card-content>
            </ion-card>

            <!-- Empty State -->
            <div *ngIf="filteredProjects.length === 0" class="empty-state">
              <ion-icon
                name="folder-open-outline"
                class="empty-icon"
              ></ion-icon>
              <h3>No projects found</h3>
              <p *ngIf="searchText">Try adjusting your search terms</p>
              <p *ngIf="!searchText">
                Create your first project to get started
              </p>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
